import React, { useState, useRef } from 'react';

import { Button } from '@material-ui/core';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import PropTypes from 'prop-types';

import IconExcel from '~/assets/icons/icons8-ms-excel.svg';
import { IconButton } from '~/components';
import {
  Form,
  DateTime,
  Select,
  Autocomplete,
  Hidden,
  RadioGroup,
} from '~/components/Form';
import { t } from '~/helpers';

import * as S from './styles';

function Header({ data, loading, handleSubmit, canExport, onExportClick }) {
  const formRef = useRef(null);
  const [agrupamento, setAgrupamento] = useState('L');

  return (
    <Form ref={formRef} initialData={data} onSubmit={handleSubmit}>
      <S.WrapperForm>
        <div className="linha-filtros">
          <div className="field-date">
            <DateTime
              name="datainicio"
              label={t('s.cadastro.contrato.datainicialcontrato')}
              serialize={(value) => value.format('DD/MM/YYYY HH:mm:ss')}
            />
          </div>

          <div className="field-date">
            <DateTime
              name="datafim"
              label={t('s.cadastro.contrato.datafinalcontrato')}
              serialize={(value) => value.format('DD/MM/YYYY HH:mm:ss')}
            />
          </div>

          <div className="field-select">
            <Select
              name="agrupamento"
              label={t('s.relatorio.abastecimento.tipoordenacao')}
              options={[
                {
                  value: 'L',
                  label: t('s.menu.cadastro.veiculo.locomotiva'),
                },
                {
                  value: 'M',
                  label: t('s.menu.cadastro.veiculo.modelo'),
                },
              ]
              }
              getValue={(value) => {
                if (value) {
                  setAgrupamento(value);
                }
              }}
            />
          </div>

          <div className="field-autocomplete">
            {agrupamento === 'L' ? (
              <React.Fragment key="filtro-locomotiva">
                <Autocomplete
                  key="autocomplete-locomotiva"
                  name="idveiculo"
                  title={t('s.menu.cadastro.veiculo.locomotiva')}
                  label="idveiculo"
                  unique="idveiculo"
                  url="veiculos"
                  params={{
                    wherefield: ['tipoveiculo'],
                    valuewherefield: [5],
                    typewherefield: ['EQUALS'],
                  }}
                />

                <Hidden key="hidden-modelo" name="idmodeloveiculo" value={0} />
              </React.Fragment>
            ) : (
              <React.Fragment key="filtro-modelo">
                <Autocomplete
                  key="autocomplete-modelo"
                  name="idmodeloveiculo"
                  title={t('s.menu.cadastro.veiculo.modelo')}
                  label="nomemodelomarcamodeloveiculo"
                  unique="idmodeloveiculo"
                  url="modelosveiculos"
                  params={{
                    wherefield: ['tipomodeloveiculo'],
                    valuewherefield: ['L'],
                    typewherefield: ['EQUALS'],
                  }}
                />

                <Hidden key="hidden-locomotiva" name="idveiculo" value="" />
              </React.Fragment>
            )}
          </div>

          <div className="field-select">
            <Select
              name="tipoCarga"
              label={t('s.relatorio.pitstopfatorconsumo.tipodecarga')}
              options={[
                {
                  value: 'A',
                  label: t('s.relatorio.geral.todos'),
                },
                {
                  value: 'T',
                  label: t('s.relatorio.lubrificacaolistagem.troca'),
                },
                {
                  value: 'C',
                  label: t('s.relatorio.pitstopfatorconsumo.complemento'),
                },
              ]
              }
            />
          </div>

          <div className="field-radio">
            <RadioGroup
              row
              name="agrupaPorDia"
              label={t('s.relatorio.pitstopfatorconsumo.agrupapordia')}
              options={[
                {
                  value: '0',
                  label: t('s.geral.opcoes.nao'),
                },
                {
                  value: '1',
                  label: t('s.geral.opcoes.sim'),
                },
              ]}
              serialize={(value) => Number(value)}
            />
          </div>

          <div className="row-botoes">
            <Button
              size="medium"
              variant="contained"
              color="primary"
              type="submit"
              disabled={loading}
              fullWidth={false}
              style={{ minWidth: 100 }}
            >
              {t('s.geral.pesquisar')}
            </Button>

            <IconButton
              type="button"
              startIcon={
                <PictureAsPdfIcon
                  style={{ color: 'white', width: 20, height: 20 }}
                />
              }
              backgroundColor="#d32f2f"
              color="white"
              iconSize={20}
              onClick={() => onExportClick('PDF')}
              style={{ minWidth: 40, width: 40, maxWidth: 40 }}
              disabled={!canExport || loading}
            />

            <IconButton
              type="button"
              startIcon={
                <img
                  src={IconExcel}
                  alt="Excel"
                  style={{
                    width: 20,
                    height: 20,
                    filter: 'invert(1)',
                  }}
                />
              }
              backgroundColor="#2e7d32"
              color="white"
              iconSize={20}
              onClick={() => onExportClick('EXCEL')}
              style={{ minWidth: 40, width: 40, maxWidth: 40 }}
              disabled={!canExport || loading}
            />
          </div>
        </div>
      </S.WrapperForm>
    </Form>
  );
}

Header.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  loading: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  canExport: PropTypes.bool.isRequired,
  onExportClick: PropTypes.func.isRequired,
};

export default Header;
